import { useEffect, useState } from "react";
import { Phone, Mail, MapPin, Clock, MessageCircle } from "lucide-react";
import { api } from "@/lib/api";

export default function Contact() {
  const [info, setInfo] = useState(null);

  useEffect(() => {
    api.get("/content/contact").then(({ data }) => setInfo(data.value)).catch(() => {});
  }, []);

  const c = info || {};

  return (
    <div data-testid="contact-page">
      <section className="pt-24 md:pt-32 pb-16 max-w-7xl mx-auto px-6 md:px-10">
        <div className="overline text-[color:var(--ek-accent)] mb-4">İletişim</div>
        <h1 className="font-display text-5xl md:text-7xl tracking-tight leading-[0.95] max-w-3xl">
          Sorunuz mu var? Konuşalım.
        </h1>
      </section>

      <section className="max-w-7xl mx-auto px-6 md:px-10 grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 mb-16">
        {[
          { icon: <Phone size={20} />, label: "Telefon", value: c.phone || "-", href: `tel:${(c.phone || "").replace(/\s/g, "")}` },
          { icon: <MessageCircle size={20} />, label: "WhatsApp", value: c.whatsapp || "-", href: `https://wa.me/${c.whatsapp || ""}` },
          { icon: <Mail size={20} />, label: "E-posta", value: c.email || "-", href: `mailto:${c.email || ""}` },
          { icon: <Clock size={20} />, label: "Çalışma Saatleri", value: c.hours || "-" },
        ].map((it, i) => {
          const Tag = it.href ? "a" : "div";
          return (
            <Tag
              key={i}
              href={it.href}
              target={it.href?.startsWith("http") ? "_blank" : undefined}
              rel="noopener noreferrer"
              data-testid={`contact-${it.label.toLowerCase()}`}
              className="p-8 border border-black/5 rounded-2xl hover:border-black/20 transition-colors flex items-start gap-5"
            >
              <span className="w-10 h-10 rounded-full bg-[color:var(--ek-accent)]/10 text-[color:var(--ek-accent)] flex items-center justify-center flex-shrink-0">
                {it.icon}
              </span>
              <div>
                <div className="overline text-neutral-500 mb-1">{it.label}</div>
                <div className="text-lg font-medium">{it.value}</div>
              </div>
            </Tag>
          );
        })}
      </section>

      <section className="max-w-7xl mx-auto px-6 md:px-10 pb-24">
        <div className="p-8 border border-black/5 rounded-2xl mb-6 flex items-start gap-5">
          <span className="w-10 h-10 rounded-full bg-[color:var(--ek-accent)]/10 text-[color:var(--ek-accent)] flex items-center justify-center flex-shrink-0">
            <MapPin size={20} />
          </span>
          <div>
            <div className="overline text-neutral-500 mb-1">Adres</div>
            <div className="text-lg font-medium">{c.address}</div>
          </div>
        </div>
        {c.map_embed && (
          <div className="rounded-2xl overflow-hidden border border-black/5 aspect-video">
            <iframe
              src={c.map_embed}
              title="Konum"
              className="w-full h-full"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        )}
      </section>
    </div>
  );
}
